import * as React from 'react'
import { useLocation } from 'react-router-dom'

/**
 * The company the user is currently looking at, taken from the URL.
 *
 * Modern routes carry `/company/:companyId/...` and are the reliable source; the
 * legacy redux `companySelection` is populated only on some paths, which is why
 * task tracking keyed on it silently did nothing on most screens.
 */
const COMPANY_ID_PATTERN = /\/company\/([0-9a-fA-F-]{36})(?:\/|$)/

export const useRouteCompanyId = (): string | null => {
  const location = useLocation()
  return React.useMemo(() => {
    const match = COMPANY_ID_PATTERN.exec(location.pathname)
    return match ? match[1] : null
  }, [location.pathname])
}
